module.exports = __webpack_public_path__ + "assets/4233b9f4ee4d04b33e859c2a6778cffe.svg";